(function (angular) {
	angular.module("bizPartEngage").directive("bizTipSomeone", bizTipSomeone);

	bizTipSomeone.$inject = ["bizCore"];

	function bizTipSomeone(bizCore) {
		var directive = {
			restrict: 'E',
			scope: {
				fromMobileMenu: '@?'
			},
			templateUrl: bizCore.getView('core.directives.tipsomeone', "FrontEnd/Core/Directives/Views/tip-someone.html"),
			bindToController: true,
			controllerAs: 'vm',
			controller: bizTipSomeoneController
		};

		bizTipSomeoneController.$inject = ["$rootScope", "$http", "$mdDialog", "$timeout"];

		function bizTipSomeoneController($rootScope, $http, $mdDialog, $timeout) {
			var vm = this;

			vm.Initialize = Initialize;
			vm.OpenPanel = OpenPanel;
			

			function OpenPanel() {
				$mdDialog.show({
					parent: angular.element(document.body),
					templateUrl: siteRootPath + "FrontEnd/Core/Directives/Views/tip-someone-popup.html",
					clickOutsideToClose: true,
					escapeToClose: true,
					controller: popupController,
					controllerAs: "vm",
					locals: {
					},
					bindToController: true
				});

				popupController.$inject = ["$mdDialog"];
				function popupController($mdDialog) {
					var vm = this;
					vm.OnBtnClick = OnBtnClick;
					vm.Close = Close;
					vm.Init = Init;

					function Init() {
									
					}

					function Close() {
						$mdDialog.hide();
					}					

					function OnBtnClick() {
						if (!vm.Email) {
							return;
						}

						vm.Clicked = true;
						vm.Error = '';
						$http.get(siteRootPath + 'api/User/TipSomeone', {
							params: {
								email: vm.Email,
								message: vm.Message || ''
							},
							headers: {
								IgnoreLoader: true
							}
						}).then(function (response) {
							var result = BizPartCoreHelpers.getResponseValue(response);
							if (result.Success) {
								vm.Sent = true;
								$timeout(() => {
									vm.Clicked = false;
									vm.Sent = false;
									vm.Email = '';
									vm.Message = '';
								}, 2000);
							} else {
								vm.Clicked = false;
								vm.Error = result.Message;
							}
						});
					}

					Init();
				}

				if (vm.fromMobileMenu) {
					$rootScope.ExpandMainMenu = false;
				}
			}
			
			

			function Initialize() {

			}

			$rootScope.Initialized.then(vm.Initialize);
		}

		return directive;
	}
})(window.angular);